import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class ServicesStatuses extends CommonCRUD {}

export default ServicesStatuses;
